'use strict';

const toggle = document.querySelector('.js-toggle-prefunding');
const form = document.querySelector('.js-prefunding-form');
const VISIBLE = 'block';
const HIDDEN = 'none';

const visible = form =>
	form.style.display !== HIDDEN;

toggle && toggle.addEventListener('click', () =>
	form.style.display = visible(form)
		? HIDDEN
		: VISIBLE
);
